import script from "./Leaderboard-v2.vue?vue&type=script&setup=true&lang=js"
export * from "./Leaderboard-v2.vue?vue&type=script&setup=true&lang=js"

import "../../scss/PendekarVR/Leaderboard-v2.scss?vue&type=style&index=0&id=56a3ebc1&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a3ebc1"]])

export default __exports__